import React from "react";
import type { FilterOption } from "../SocialFilterSelect";

interface Props<T extends string> {
  label: string;
  value: T;
  defaultId: T;
  options: FilterOption<T>[];
  onChange: (id: T) => void;
  testId?: string;
}

/** Filtro del teléfono: etiqueta y select nativo de 40 px; abre el selector del sistema operativo. */
export function SocialFilterSelectMobile<T extends string>({ label, value, defaultId, options, onChange, testId }: Props<T>) {
  return (
    <label className="sbx-chip-select-m" data-active={value !== defaultId || undefined}>
      <span>{label}</span>
      <select className="compact-select" value={value} data-testid={testId} onChange={(e) => onChange(e.target.value as T)}>
        {options.map((o) => (
          <option key={o.id} value={o.id}>
            {o.label}
          </option>
        ))}
      </select>
    </label>
  );
}
